import { abi } from './abi';
class DelegateManager {
}
DelegateManager.abi = abi;
DelegateManager.address = '0x4d7968ebfD390D5E7926Cb3587C39eFf2F9FB225';
export { DelegateManager };
//# sourceMappingURL=delegateManager.js.map